export function formatPersianDate(date) {
  if (!date) return '---';

  const utcString =
    typeof date === 'string'
      ? (date.includes('T') ? date : date.replace(' ', 'T')) +
      (date.endsWith('Z') ? '' : 'Z')
      : date;

  const tehranDateTime = new Intl.DateTimeFormat('fa-IR', {
    timeZone: 'Asia/Tehran',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  }).format(new Date(utcString));

  return tehranDateTime;
}
